'use client';
import { Banner } from '@airbus/components-react';
import Spinners from '../../shared/components/Spinner';
import GridTable from '../../shared/components/grid/GridTable';
import Layout from '../../shared/components/layout';
import useFetchScreenDetails from '../../shared/utils/useFetchScreenDetails';
import GetAllColumnContextProvider, {
  useColumnContextAPI,
} from '../../shared/context/GetAllColumnContext';
import { useEffect, useState } from 'react';
import { t } from '../../i18next';
import { getChildTableDetailsService } from '../../features/getChildTableDetailsService';
import HeaderScreenList from '../../features/attributes_access/components/HeaderScreenList';
import SetColumnConfig from '../../shared/components/grid/SetColumnConfig';
import { useConfigContext } from '../../shared/context/ConfigContext';

const DropdownPage = () => {
  const { loading, error, screenTables, details } = useFetchScreenDetails('dropdowns');
  const screenId = details?.screenId;
  const [screenOptions, setScreenOptions] = useState([]);
  const [selectedScreen, setSelectedScreen] = useState(null);
  const { configSchema } = useConfigContext();

  useEffect(() => {
    if (screenId && screenTables) {
      const screenGridId = screenTables[0]?.id;
      getChildTableDetailsService(screenGridId, screenId, configSchema).then((res) => {
        const options = res[`${configSchema}_mbd_screen_to_data_grids`]?.map((item) => ({
          value: item.id,
          label: item.mbdDatagrid.dataGridInternalName,
        }));
        setScreenOptions(options);
        if (options?.length > 0) {
          setSelectedScreen(options[0]?.value);
        }
      });
    }
  }, [screenId, screenTables]);

  return (
    <>
      {loading ? (
        <Spinners />
      ) : (
        <Layout>
          {error && <Banner variant='warning'>{t('data_not_available')}</Banner>}
          {screenTables && screenTables.length > 0 && selectedScreen && (
            <GetAllColumnContextProvider key={selectedScreen}>
              <Dropdown
                selectedScreen={selectedScreen}
                setSelectedScreen={setSelectedScreen}
                screenOptions={screenOptions}
                screenTables={screenTables}
              />
            </GetAllColumnContextProvider>
          )}
        </Layout>
      )}
    </>
  );
};

export default DropdownPage;

const Dropdown = ({ selectedScreen, setSelectedScreen, screenOptions, screenTables }) => {
  const { updateCustomConfig } = useColumnContextAPI();
  const [filteredScreenTables, setfilteredScreenTables] = useState([]);

  useEffect(() => {
    const filteredTables = screenTables
      .filter((item) => item.id === selectedScreen)
      .map((item) => ({
        ...item,
        mbdDataGrid: { ...item.mbdDataGrid },
      }));
    setfilteredScreenTables(filteredTables);
  }, [selectedScreen, screenTables]);

  useEffect(() => {
    if (selectedScreen) {
      const pkeyColumn = filteredScreenTables[0]?.mbdDataGrid?.dataGridUniqueIdentifier;
      updateCustomConfig({
        ScreenSlotProps: {
          updateValue: setSelectedScreen,
          initialValue: selectedScreen,
          screenOptions,
          customGridProps: {
            pagination: null,
            columnVisibilityModel: {
              id: true,
            },
          },
        },
        AdditionalHeaderComp: [{ name: 'headerScreenList', Component: HeaderScreenList }],
        AdditionalSortQuery: `(order_by: {${pkeyColumn}: asc})`,
        SetColumnConfig: dropdownsColumnConfig,
        uniqueValidator: pKeyValidator,
        SetIsCellEditable,
      });
    }
  }, [selectedScreen, screenOptions, filteredScreenTables]);

  return filteredScreenTables.map((item) => <GridTable key={item.id} tableRes={item} />);
};

function dropdownsColumnConfig(props) {
  const { gridColumns: columnsConfig } = SetColumnConfig(props);
  const gridColumns = columnsConfig.reduce((resp, item) => {
    if (item.attrDataType === 'string') {
      item.renderCell = (params) => {
        const { colDef } = params;
        colDef.width = 120;
      };
    }
    resp.push(item);
    return resp;
  }, []);

  return { gridColumns };
}

function pKeyValidator(rows, row, pkeyColumn) {
  const result = {
    isValid: true,
    errors: {},
  };
  if (pkeyColumn == 'werk' || pkeyColumn == 'ps') {
    const filteredRow = rows.filter((item) => {
      return !item.status;
    });
    if (row[pkeyColumn]) {
      const newCheck = filteredRow.findIndex((item) => item[pkeyColumn] == row[pkeyColumn]);
      if (newCheck >= 0) {
        result.isValid = false;
        result.errors[pkeyColumn] = {
          field: pkeyColumn,
          msg: `The value ${row[pkeyColumn]} already exists`,
        };
      }
    }
  }
  return result;
}

function SetIsCellEditable(props) {
  const { field, row, access } = props;
  let isEditable = true;
  if ((field === 'werk' || field === 'ps') && row.status !== 'N') {
    isEditable = false;
    return isEditable;
  }
  const rolePermission = access?.[field]?.accessLevel === 'U';
  return row.status !== 'D' && access?.edit_row && isEditable && rolePermission;
}
